import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getDashboardData } from '../../Api/DashboardData';
import { getAlertsData } from '../../Api/AlertData';
import { useAuth } from '../../context/AuthContext';
import useGlobalVessel from '../../components/useGlobalVessel';
import useDashboardResource from './useDashboardResource';
import DashboardView from './DashboardView';

export default function Dashboard() {
    const vessel = useGlobalVessel();
    const { user } = useAuth();
    const navigate = useNavigate();
    const isAdmin = user?.role === 'Admin';
    const [refresh, setRefresh] = useState(0);
    const [choice, setChoice] = useState(null);
    const reload = () => setRefresh(value => value + 1);
    useEffect(() => {
        document.title = 'NextSense - Dashboard';
        const timer = setInterval(() => setRefresh(value => value + 1), 60000);
        return () => clearInterval(timer);
    }, []);
    const identity = { accountId: vessel?.accountId, objectCode: vessel?.objectCode };
    const current = useDashboardResource(getDashboardData, '/current', identity, !!vessel, refresh);
    const items = current.data?.items || [];
    const sensor = (choice?.scope === vessel?.key && items.find(row => row.SensorCode === choice.sensor)) || items.find(row => row.RefDate) || items[0];
    const trend = useDashboardResource(getDashboardData, '/trend', { ...identity, sensor: sensor?.SensorCode, end: current.data?.asOf }, !!vessel && !!sensor && !!current.data, refresh);
    const alerts = useDashboardResource(getAlertsData, '', { ...identity, start: current.data?.alertStart, end: current.data?.asOf, tab: 'history', page: 1 }, isAdmin && !!vessel && !!current.data, refresh);
    const openAlerts = () => navigate('/dashboard/alerts?' + new URLSearchParams({ KodeCabang: vessel.accountId, ShipCode: vessel.objectCode }));
    return <DashboardView refresh={refresh} vessel={vessel} isAdmin={isAdmin} current={current} trend={trend} alerts={alerts} sensor={sensor}
        onSensorChange={value => setChoice({ scope: vessel.key, sensor: value })} onRefresh={reload} onAlerts={openAlerts} />;
}
